import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-white pt-5 pb-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="d-flex align-items-center mb-3">
              <img src="/images/sp_mark_v2.svg" alt="" width="36" height="36" className="me-2" />
              <h4 className="mb-0">Sustainability <span className="text-primary">Pros</span></h4>
            </div>
            <p className="mb-4">Optimizing building performance through innovative asset condition assessment and maintenance optimization solutions. We're committed to reducing operational costs and extending equipment life.</p>
          </div>
          
          <div className="col-lg-2 col-md-6 mb-4 mb-md-0">
            <h5 className="text-uppercase mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-white text-decoration-none">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-white text-decoration-none">About Us</Link>
              </li>
              <li className="mb-2">
                <Link to="/services" className="text-white text-decoration-none">Services</Link>
              </li>
              <li className="mb-2">
                <Link to="/mep-tools" className="text-white text-decoration-none">MEP Tools</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white text-decoration-none">Contact</Link>
              </li>
            </ul>
          </div>
          
          <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 className="text-uppercase mb-4">Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/services" className="text-white text-decoration-none">Existing Building Assessment</Link>
              </li>
              <li className="mb-2">
                <Link to="/services" className="text-white text-decoration-none">Energy & Sustainability Analysis</Link>
              </li>
              <li className="mb-2">
                <Link to="/services" className="text-white text-decoration-none">Design Document Review</Link>
              </li>
              <li className="mb-2">
                <Link to="/services" className="text-white text-decoration-none">Commissioning Support</Link>
              </li>
              <li>
                <Link to="/mep-tools" className="text-white text-decoration-none">MEP Tools Software</Link>
              </li>
            </ul>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <h5 className="text-uppercase mb-4">Contact Info</h5>
            <ul className="list-unstyled">
              <li className="mb-3 d-flex">
                <i className="bi bi-envelope-fill text-primary me-2 mt-1"></i>
                <a href="mailto:info@sustainability-pros.com" className="text-white text-decoration-none">info@sustainability-pros.com</a>
              </li>
              <li className="mb-3 d-flex">
                <i className="bi bi-geo-alt-fill text-primary me-2 mt-1"></i>
                <span>Raleigh-Durham, NC</span>
              </li>
              <li className="d-flex">
                <i className="bi bi-clock-fill text-primary me-2 mt-1"></i>
                <span>Mon - Fri: 8:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
        
        <hr className="my-4" />
        
        <div className="row align-items-center">
          <div className="col-12">
            <p className="mb-0">
              © {currentYear} <strong>Sustainability Pros</strong>. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;